// @flow
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import Slider from 'react-slick';
import step1 from '../../../assets/img/stores/steps/info1.png';
import step2 from '../../../assets/img/stores/steps/info2.png';
import step3 from '../../../assets/img/stores/steps/info3.png';
import inputStyle from '../../../assets/styles/input.scss';
import {FormValidator} from '../../../utils/form';
import {Default, Mobile, Desktop, UntilTablet} from '../../../utils/responsive';
import {urlVerifier} from '../../../utils/string';
import CustomBanner from '../../home/elements/CustomBanner/CustomBanner';

import style from './Apple.scss';
import buttonStyle from '../../../assets/styles/button.scss';
import iphone13 from '../../../assets/img/home/banner-carousel/new-banner/iPhone13.png';

import appleMisc from '../../../assets/img/apple/apple_misc.png';
import iphoneHero from '../../../assets/img/apple/iphone_hero.png';
// import iphone12 from '../../../assets/img/apple/iphone_12.png';
import iphone14 from '../../../assets/img/apple/iphone_14.png';
import iphone15 from '../../../assets/img/apple/iphone_15.png';
import iphone16 from '../../../assets/img/home/banner-carousel/new-banner/iPhone16.png';
import iphone12Bottom from '../../../assets/img/apple/iphone_12_bottom.png';
// import iphone11 from '../../../assets/img/apple/iphone_11.png';
import ipadPro from '../../../assets/img/apple/ipad_pro.png';
import ipadAir from '../../../assets/img/apple/ipad_air.png';
import airpodsCC from '../../../assets/img/custom-products/airpods/with-charger.png';
import airpodsWC from '../../../assets/img/custom-products/airpods/with-wireless-chager.png';
import airpodsP from '../../../assets/img/custom-products/airpods/pro.png';
import iphone14Banner from '../../../assets/img/home/banner-carousel/new-banner/iPhone14.png';
import iphone15Banner from '../../../assets/img/home/banner-carousel/new-banner/iPhone15.png';

import type {OnlineStore} from '../../../entities';
import type {FormValidationResult} from '../../../utils/form';
import type {Node} from 'react';

type Props = {
  +goToRedirect: (route: string) => void;
};

type State = {
  url: {
    value: string;
    errors?: string[];
  };
};

const appleStore: OnlineStore = {
  id: "ST08333814",
  logo: "https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Apple.png",
  name: "Apple",
  slug: "apple",
  type: "online-store",
  url: "https://www.apple.com/",
}

const settings = {
  dots: true,
  arrows: false,
  draggable: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  dotsClass: classNames('slick-dots', style.dots),
};

const steps = [
  {
    img: step1,
    text: '1. Busca el producto que deseas en la tienda',
  },
  {
    img: step2,
    text: '2. Copia el URL o enlace del producto',
  },
  {
    img: step3,
    text: '3. Regresa a Qempo y pega e URL o enlace del producto',
  }
];

export default class Apple extends Component<Props, State> {
  formValidator: FormValidator;
  state = {
    url: {
      value: '',
    },
  };

  constructor(props: Props) {
    super(props);
    this.formValidator = new FormValidator({
      url: {
        required: 'required',
      },
    });
  }

  buildInfos(): Node[] {
    return steps.map((step, index: number) => (
      <article className={style.step}
               key={index}>
        <section className={style.picture}>
          <img className={style.backImage} src={step.img} alt="Qempo"/>
          {index !== 2 && <img className={style.logoStore}
                               src={appleStore.logo}
                               alt={appleStore.name}/>}
          {/*<div className={style.number}>{index + 1}</div>*/}
        </section>
        <p>{step.text}</p>
      </article>)
    );
  }

  handleFocus(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const {name} = e.target;
      this.setState({[name]: {value: this.state[name].value}});
    }
  }

  handleBlur(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const {name, value} = e.target;
      const errors = this.formValidator.validateField(name, value);
      if (errors.length && (errors[0] === 'urlFormat')) {
        this.setState({[name]: {value, errors}});
      } else {
        this.setState({[name]: {value}});
      }
    }
  }

  handleChange(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const {name, value} = e.target;
      this.setState({[name]: {value}});
    }
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    const {goToRedirect} = this.props;
    const {url} = this.state;
    const errors = this.formValidator.validateForm({
      url: url.value,
    });

    if (errors.length) {
      errors.forEach(
        (error: FormValidationResult) =>
          this.setState(
            (state: State) => ({
                [error.field]: {
                  ...state[error.field],
                  errors: error.errors,
                },
              }
            )),
      );
    } else {
      if (urlVerifier(url.value) || url.value.startsWith('http')) {
        goToRedirect(`/new-order/product?initialQuery=${url.value}`);
      } else {
        goToRedirect(`/new-order/search?name=${url.value}`);
      }
    }
    return false;
  }

  render() {
    const {url} = this.state;

    const urlError = url && url.errors && FormValidator.buildErrorLabel(url.errors, {
      required: 'newOrder.scrap.error.required',
      urlFormat: 'newOrder.scrap.error.format',
    });

    const airpods = [
      <div key="apds-cc" className={style.modelWrap}>
        <div key="apds-cc" className={style.model}>
          <img src={airpodsCC} alt="airpods-charging-case-peru"/>
          <p className={style.title}>Airpods</p>
          <p className={style.text}>with Charging Case</p>
          <div className={style.buttonWrap}>
            <FormattedMessage id="newOrder.scrap.button.quoteFree">{
              text => <a className={classNames(buttonStyle.btn,
                buttonStyle.lightBlue,
                style.button)}
                         href="/custom-product/airpods-with-charging-case?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                         target="_blank">{text}</a>
            }</FormattedMessage>
          </div>
        </div>
      </div>,
      <div key="apds-wc" className={style.modelWrap}>
        <div key="apds-wc" className={style.model}>
          <img src={airpodsWC} alt="airpods-wireless-charging-case-peru"/>
          <p className={style.title}>Airpods</p>
          <p className={style.text}>with Wireless Charging Case</p>
          <div className={style.buttonWrap}>
            <FormattedMessage id="newOrder.scrap.button.quoteFree">{
              text => <a className={classNames(buttonStyle.btn,
                buttonStyle.lightBlue,
                style.button)}
                         href="/custom-product/airpods-with-wireless-charging-case?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                         target="_blank">{text}</a>
            }</FormattedMessage>
          </div>
        </div>
      </div>,
      <div key="apds-p" className={style.modelWrap}>
        <div key="apds-p" className={style.model}>
          <img src={airpodsP} alt="airpods-wireless-charging-case-peru"/>
          <p className={style.title}>Airpods Pro</p>
          <p className={style.text}>&nbsp;</p>
          <div className={style.buttonWrap}>
            <FormattedMessage id="newOrder.scrap.button.quoteFree">{
              text => <a className={classNames(buttonStyle.btn,
                buttonStyle.lightBlue,
                style.button)}
                         href="/custom-product/airpods-pro?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                         target="_blank">{text}</a>
            }</FormattedMessage>
          </div>
        </div>
      </div>,
    ];

    return (
      <Fragment>
        <div className={style.appleWrap}>
          <div className={style.heroWrap}>
            <div className={style.heroContentWrap}>
              <h1>Apple Perú</h1>
              <p>
                En Qempo encontrarás los mejores dispositivos de Apple Peru traídos directamente desde Estados Unidos.
                Aquí podrás pedir los más recientes modelos de iPhones, iPads y los accesorios tecnológicos más
                innovadores,
                como AirPods, Apple Watch y más. Podrás comparar también los diferentes precios, características y
                avances
                de cada equipo, es decir, toda la información que necesitas para realizar tu compra.
              </p>
              <img src={iphoneHero} alt="iPhone"/>
            </div>
          </div>
          
          <div className={style.iphone14Wrap}>
            <div className={style.iphone14ContentWrap}>
              <h2 className={classNames(style.sectionSubtitle, style.center)}>iPhone 16</h2>
              <p className={style.iphones}>
                iPhone 16 | iPhone 16 Plus | iPhone 16 Pro | iPhone 16 Pro Max
              </p>
              <span className={style.sizes}>128GB - 256GB - 512GB -  1TB</span>
              <a className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                 href="/custom-product/iphone-16?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                 target="_blank">
                Cotizar Gratis
              </a>
              <img src={iphone16} alt="iphone 16 peru"/>
              <p className={style.sectionText}>
                El nuevo iPhone 16 Perú es el mejor teléfono del mercado actualmente. Con el nuevo sistema operativo iOS18, Apple Intelligence, puerto USB-C y el procesador A18 Pro, Apple Perú ha revolucionado el mundo de los smartphones. La nueva cámara de 48 megapixeles para tu versión estándar, Pro y Pro Max, marcan gran diferencia. Si buscas un nuevo teléfono a un precio muy competitivo, el iPhone 16 Perú es tu mejor opción.
              </p>
            </div>
          </div>
          <div className={style.iphoneWrap}>
            <CustomBanner
              positionButton="left"
              button={(
                <a className={classNames(
                  buttonStyle.btn,
                  buttonStyle.cream,
                  style.button
                )}
                   href="https://www.qempo.com.pe/custom-product/iphone-15?utm_source=Web&utm_medium=home&utm_campaign=home_banner_iphone_15"
                   target="_blank">
                  Cotizar GRATIS
                </a>
              )}
              background="#000"
              left={(
                <div className={style.textIphone15}>
                  <span>Tu nuevo <strong>iPhone 15</strong> sin trámites, sin aduanas y
                    <strong> sin impuestos.</strong>
                  </span>
                </div>
              )}
              sideImage={{
                image: iphone14Banner,
                position: 'right'
              }}
              direction="normal"
            />
          </div>
          
          <div className={classNames(style.middleWrap, style.ipadPro)}>
            <div className={style.contentWrap}>
              <h2 className={classNames(style.desktop, style.sectionSubtitle)}>iPad Pro 2021</h2>
              <p className={style.sectionText}>
                El iPad Pro 2021 es el dispositivo más veloz en su clase. Su potente chip Apple M1 brinda el máximo
                rendimiento y una batería que dura todo el día. Además, su pantalla Liquid Retina XDR de 12,9 pulgadas
                te ofrece una experiencia de visualización avanzada. Junto a su sistema integrado de mini-LEDS, el
                iPad Pro 2021 pone en tus manos una increíble eficiencia energética conservando su diseño liviano y
                portátil.
              </p>
              <a className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                 href="/custom-product/ipad-pro-11-inch-wifi?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                 target="_blank">
                Cotizar Gratis
              </a>
            </div>
            <div className={style.imageWrap}>
              <img src={ipadPro} alt="ipad pro 2021 peru"/>
            </div>
            <h2 className={classNames(style.mobile, style.sectionSubtitle)}>iPad Pro 2021</h2>
          </div>
          <div className={classNames(style.middleWrap, style.ipadAir)}>
            <h2 className={classNames(style.mobile, style.sectionSubtitle)}>iPad Air</h2>
            <div className={style.imageWrap}>
              <img src={ipadAir} alt="ipad air peru"/>
            </div>
            <div className={style.contentWrap}>
              <h2 className={classNames(style.desktop, style.sectionSubtitle)}>iPad Air</h2>
              <p className={style.sectionText}>
                Un modelo más potente con el diseño más ligero de Apple Peru. El iPad Air posee el nuevo chip A14 Bionic
                que optimiza el rendimiento en casi todas las aplicaciones y un Neural Engine de 16 núcleos de última
                generación. El iPad Air posee también una pantalla Liquid Retina de 10.9 pulgadas y es compatible con
                Apple Pincel y el Magic Keyboard.
              </p>
              <a className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                 href="/custom-product/ipad-air-10.9-inch-wifi?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                 target="_blank">
                Cotizar Gratis
              </a>
            </div>
          </div>
          <div className={style.airpodsWrap}>
            <h2 className={classNames(style.center, style.sectionSubtitle)}>AirPods</h2>
            <div className={style.modelsWrap}>
              <Desktop>
                {airpods}
              </Desktop>
              <UntilTablet>
                <Slider ref="slick" {...settings}>
                  {airpods}
                </Slider>
              </UntilTablet>
            </div>
            <p className={style.text}>
              Accede a los últimos modelos de AirPods de Apple Peru, los dispositivos de audio pioneros en tecnología
              inalámbrica. Los AirPods ofrecen una calidad de sonido incomparable, gracias a su innovador sistema de
              anulación de ruido externo. Cuentan además con una duración de batería de hasta 5 horas (con una sola
              carga) y se conectan fácilmente a tus equipos iPhone, Apple Watch, iPad y Mac.
            </p>
          </div>
          {/*<div className={style.iphone12Wrap}>
            <div className={style.contentWrap}>
              <h2 className={style.sectionSubtitle}>iPhone 12</h2>
              <p className={style.sectionText}>
                El smartphone más veloz de Apple Peru. El iPhone 12 cuenta con el novedoso chip A14 Bionic y gracias a
                su pantalla OLED verás brillos más intensos, negros más oscuros y una mayor resolución.
                Protegido por el vidrio Ceramic Shield, es cuatro veces más resistente a caídas.
                Además, con su sistema dual de cámaras gran angular y ultra gran angular,
                tomarás mejores fotos en condiciones de poca luz.
              </p>
              <a className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                 href="/custom-product/iphone-12?utm_source=Web&utm_medium=landing&utm_campaign=landing_apple"
                 target="_blank">
                Cotizar Gratis
              </a>
            </div>
            <img src={iphone12Bottom} alt="iphone 12 peru"/>
          </div>*/}

          <div className={style.carouselWrap}>
            <div className={style.topWrap}>
              <h3>¿Buscas otro producto Apple?</h3>
              <img src={appleMisc} alt="apple peru"/>
            </div>
            <section className={style.carousel}>
              <Mobile>
                <Slider ref="slick" {...settings}>
                  {this.buildInfos()}
                </Slider>
              </Mobile>
              <Default>
                {this.buildInfos()}
              </Default>
            </section>
            <a className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
               href="https://www.apple.com/"
               target="_blank">
              Ir a apple
            </a>
          </div>

          <div className={style.searchWrap}>
            <div className={style.contentWrap}>
              <h3>¿Buscas otro producto Apple?</h3>
              <p className={style.sectionText}>Pega el link y cotízalo de inmediato aquí</p>
              <section className={style.inputWrap}>
                <form action="/new-order/product"
                      onSubmit={this.handleSubmit.bind(this)}>
                  <FormattedMessage id="newOrder.scrap.url.placeholder">{
                    txt => <input type="text"
                                  name="url"
                                  value={url.value}
                                  className={classNames(inputStyle.input,
                                    {[inputStyle.red]: url.errors && url.errors.length})}
                                  onFocus={this.handleFocus.bind(this)}
                                  onBlur={this.handleBlur.bind(this)}
                                  onChange={this.handleChange.bind(this)}
                                  placeholder={txt}
                                  autoComplete="disabled"/>
                  }</FormattedMessage>
                  <FormattedMessage id="newOrder.scrap.button.quoteFree">{
                    text => <button type="submit"
                                    className={classNames(buttonStyle.btn,
                                      buttonStyle.lightBlue,
                                      style.button)}>{text}</button>
                  }</FormattedMessage>
                  {urlError}
                </form>
              </section>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

Apple.propTypes = {
  goToRedirect: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/apple/components/Apple.jsx